export default [
 {
   "colour_code": "#DA1A0F",
   "sentiment": -0.5
 },
 {
   "colour_code": "#FCF275",
   "sentiment": 0.4
 },
 {
   "colour_code": "#87B824",
   "sentiment": 0.1
 },
 {
   "colour_code": "#ECAB60",
   "sentiment": -0.1
 },
 {
   "colour_code": "#439D37",
   "sentiment": 0
 }, 
 // {
 //   "colour_code": "#7aba72",
 //   "sentiment": 0
 // },
 {
   "colour_code": "#AACD6F",
   "sentiment": 0.2
 },
 {
   "colour_code": "#E8E88F",
   "sentiment": 0.3
 },
 {
   "colour_code": "#F29053",
   "sentiment": -0.2
 },
 {
   "colour_code": "#EA683C",
   "sentiment": -0.3
 },
 {
   "colour_code": "#E85E37",
   "sentiment": -0.4
 },
 {
   "colour_code": "#FFF60D",
   "sentiment": 0.9
 },
 {
   "colour_code": "#FFF60D",
   "sentiment": 1
 },
 {
   "colour_code": "#FFF60D",
   "sentiment": 0.6
 },
 {
   "colour_code": "#FFF60D",
   "sentiment": 0.7
 },
 {
   "colour_code": "#FFF60D",
   "sentiment": 0.5
 },
 {
   "colour_code": "#FFF60D",
   "sentiment": 0.8
 }
]
